module.exports = __webpack_public_path__ + "static/media/gear.bad035b2.png";